export const wrappedTypeResponse = Object.freeze({
  JSON:"JSON",
  TEXT:"TEXT",
  BLOB:"BLOB",
  ARRAYBUFFER:"ARRAYBUFFER"
});
